<template>
  <div class="modal-panel">
    <div class="modal-head">
      <h3 class="modal-title">Confirmar eliminación</h3>
    </div>

    <div class="modal-body">
      <p class="modal-text">
        ¿Estás seguro de eliminar <strong class="text-error">"{{ nombre }}"</strong>? Esta acción no se puede deshacer.
      </p>
    </div>

    <div class="modal-footer">
      <button class="btn-ghost" @click="cerrarDialogo">Cancelar</button>
      <button class="btn-danger-solid" @click="eliminar">Aceptar</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "DialogoEliminar",
  props: ["nombre"],

  methods: {
    cerrarDialogo() {
      this.$emit("cancelar", false)
    },

    eliminar() {
      this.$emit("eliminar", true)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&display=swap');

.modal-panel {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}

.modal-body {
  padding: 24px;
}

.modal-text {
  font-size: 13.5px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.6;
}

.text-error {
  color: var(--error);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

.btn-danger-solid {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--error);
  color: #0E0E10;
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-danger-solid:hover {
  filter: brightness(1.1);
}
</style>


// WEBPACK FOOTER //
// src/components/Dialogos/DialogoEliminar.vue